// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../cache/REACT_API_PROD/nc_react_ui_node_modules_cache/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smses-component .smses {
  height: 100%;
  margin-bottom: 4px;
}
.smses-component .smses .ant-card-body {
  padding: 0;
  border: 0;
  height: 100%;
}
.smses-component .smses .ant-card-body .smses-main-row {
  height: 100%;
  flex-flow: row nowrap !important;
}
.smses-component .smses .card-with-chat-list,
.smses-component .smses .card-with-chat-messages {
  height: 100%;
  max-height: 95vh;
  min-height: 60vh;
}
.smses-component .smses .card-with-chat-list .ant-card-body,
.smses-component .smses .card-with-chat-messages .ant-card-body {
  height: 100%;
  padding: 4px;
}
.smses-component .smses .twilio-control-buttons {
  text-align: right;
}
.smses-component .smses .ant-card-head {
  min-height: 0px !important;
}
.smses-component .smses .ant-card-head .ant-card-head-title {
  padding: 4px 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/smses/sms-messages/styles.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;EACA,kBAAA;AAAJ;AAHA;EAMM,UAAA;EACA,SAAA;EACA,YAAA;AAAN;AARA;EAWQ,YAAA;EACA,gCAAA;AAAR;AAZA;;EAkBM,YAAA;EAGA,gBAAA;EACA,gBAAA;AAJN;AAlBA;;EAwBQ,YAAA;EACA,YAAA;AAFR;AAvBA;EA8BM,iBAAA;AAJN;AA1BA;EAkCM,0BAAA;AALN;AA7BA;EAqCQ,yBAAA;AALR","sourcesContent":[".smses-component {\n  .smses {\n    height: 100%;\n    margin-bottom: 4px;\n\n    .ant-card-body {\n      padding: 0;\n      border: 0;\n      height: 100%;\n\n      .smses-main-row {\n        height: 100%;\n        flex-flow: row nowrap !important;\n      }\n    }\n\n    .card-with-chat-list,\n    .card-with-chat-messages {\n      height: 100%;\n\n      // this set the main height for all SMS page\n      max-height: 95vh;\n      min-height: 60vh;\n      .ant-card-body {\n        height: 100%;\n        padding: 4px;\n      }\n    }\n\n    .twilio-control-buttons {\n      text-align: right;\n    }\n\n    .ant-card-head {\n      min-height: 0px !important;\n\n      .ant-card-head-title {\n        padding: 4px 0 !important;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
